import { styled, SxProps, Theme } from '@mui/material';
import React from 'react';

interface ITabPanelProps {
	sx?: SxProps<Theme>;
	children?: React.ReactNode;
	index: number;
	value: number;
}

const Container = styled('div', { name: 'TabPanel' })({
	'&:not([hidden])': { display: 'flex' },
	flexDirection: 'column',
});

const TabPanelInner = styled('div', { name: 'TabPanelInner' })({
	p: 0,
	flex: 1,
});

export default function TabPanel(props: ITabPanelProps): JSX.Element {
	const { children, value, index, ...other } = props;

	return (
		<Container role="tabpanel" hidden={value !== index} {...other}>
			{value === index && <TabPanelInner>{children}</TabPanelInner>}
		</Container>
	);
}
